export default function formatPrice(
  price,
  fractionDigits = 0,
  currency = 'DKK',
  locale = 'da-DK'
) {
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits
  })
  return formatter.format(price)
}
